/**
 * Full-page maintenance view shown to logged-in users when appConfiguration.app.maintenance is true.
 * Public (signed-out) users and signing links are unaffected.
 */
export function MaintenancePage() {
  return (
    <div className="maintenance-page">
      <div className="maintenance-page__bg" aria-hidden />
      <div className="maintenance-page__card">
        <div className="maintenance-page__icon" aria-hidden>
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h1 className="maintenance-page__title">We're currently under maintenance</h1>
        <p className="maintenance-page__message">
          The site will be back shortly. Please contact us for anything urgent.
        </p>
        <a href="/#contact" className="maintenance-page__contact">
          Contact us
        </a>
        <a href="/" className="maintenance-page__btn">
          Back to main website
        </a>
      </div>
    </div>
  )
}
